"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccountingAutoSyncEnabled = isAccountingAutoSyncEnabled;
exports.readStoredAccountingAutoSync = readStoredAccountingAutoSync;
/**
 * Resolves whether automatic Xero invoice sync is enabled for a product.
 *
 * Stored as `business_accounting_integrations.metadata.autoSync` (boolean).
 * When unset:
 * - Handshake defaults to **enabled** (preserve existing paid auto-sync)
 * - Nucleus defaults to **disabled** (opt-in)
 */
function isAccountingAutoSyncEnabled(metadata, sourceApp) {
    const raw = metadata && typeof metadata === "object"
        ? metadata.autoSync
        : undefined;
    if (raw === true)
        return true;
    if (raw === false)
        return false;
    return sourceApp === "handshake";
}
/** Stored value for API/status responses (`null` when never set). */
function readStoredAccountingAutoSync(metadata) {
    const raw = metadata && typeof metadata === "object"
        ? metadata.autoSync
        : undefined;
    if (raw === true)
        return true;
    if (raw === false)
        return false;
    return null;
}
